import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';

import { Modal, Button, IconButton, Typography } from '@mui/material';
import { Close, CloudUpload, Cancel } from '@mui/icons-material';

import api from '@utils/axiosInstance';

function ThumbnailModal({ modalOpen, setModalOpen, url, idx }) {
    const [files, setFiles] = useState([]);
    const [uploadUrl, setUploadUrl] = useState([]);
    const [isChanged, setIsChanged] = useState(0);

    const { uuid } = useParams();

    const organizationData = useSelector(state => state.organization.organizationData);
    const userToken = useSelector(state => state.organization.userToken);
    const cdn = useSelector(state => state.organization.cdn);

    const { t } = useTranslation();

    useEffect(() => {
        if (modalOpen) {
            api({
                method: 'post',
                url: '/common/getThumbUploadUrl',
                data: {
                    tk: userToken,
                    uuid: uuid,
                    ogc: organizationData.organization_code,
                    idx: idx + 1
                }
            })
                .then((response) => {
                    if (response.data.code == 100) {
                        setUploadUrl(response.data.upload_url);
                    }
                    console.log('response', response)
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        else { setUploadUrl([]); setFiles([]); setIsChanged(0); }

    }, [modalOpen])


    function UploadThumb(data) {
        setIsChanged(1);

        api({
            method: 'put',
            url: uploadUrl,
            headers: {
                'Content-Type': 'image/png'
            },
            data: data
        })
            .then(function (response) {
                console.log(response);
            })
            .then(function () {
                api({
                    method: 'post',
                    url: '/common/setThumb',
                    data: {
                        tk: userToken,
                        uuid: uuid,
                        ogc: organizationData.organization_code,
                        idx: idx + 1
                    }
                })
                    .then((response) => {
                        if (response.data.code == 100) {
                            setIsChanged(2);
                        }
                        console.log('setThumb response', response)
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const onDrop = useCallback(acceptedFiles => {

        setFiles(acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file),
            blob: file
        })));

        console.log('URL.createObjectURL(file)', URL.createObjectURL(acceptedFiles[0]))
    }, [])

    const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({ onDrop, multiple: false, accept: { "image/png": ['.png'] } })

    const RootProps = {
        ...getRootProps(),
    };

    useEffect(() => () => {
        // createObjectURL 로 생성한 URL을 revokeObjectURL 로 제거 해준다
        // 메모리 누수를 방지하기 위해 생성된 URL을 DOM과 바인딩한 후에는 해제하는 것이 좋다고한다.
        files.forEach(file => URL.revokeObjectURL(file.preview));
    }, [files]);

    //현재 업로드한 이미지 파일을 취소하는 기능
    const handleCancle = () => {
        console.log('cancle')
        setFiles([])
    }

    return (
        <Modal
            className="thumbnail-modal"
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            disablePortal
        >
            <div className="modal-content">
                <div className="modal-header">
                    <Typography variant="h2">{t('vod.manage.info_tab.thumbnail_replace')}</Typography>
                    <IconButton className="close-button" onClick={() => setModalOpen(false)}>
                        <Close />
                    </IconButton>
                </div>
                <div className="modal-body">
                    <div className="thumbnail-container">
                        {files.length > 0 ? (
                            <img className="thumbnail-image" src={files[0].preview} alt={t('vod.manage.info_tab.new_thumbnail')} />
                        ) : (
                            <img className={`thumbnail-image ${isDragActive ? 'active' : ''}`} src={url} alt={t('vod.manage.info_tab.current_thumbnail')} />
                        )}
                        {isDragReject && (
                            <div className="drag-reject-icon">
                                <Cancel />
                            </div>
                        )}
                        {isDragActive && !isDragReject && (
                            <div className="drag-active-icon">
                                <div className="loading-spinner"></div>
                            </div>
                        )}
                    </div>

                    {files.length > 0 ? (
                        <div className="button-container">
                            <div className="button-wrapper">
                                {isChanged === 0 && (
                                    <Button variant="contained" color="primary" onClick={() => UploadThumb(files[0].blob)}>
                                        <Typography variant="button">{t('vod.manage.info_tab.replace')}</Typography>
                                    </Button>
                                )}
                                {isChanged === 1 && (
                                    <Button variant="contained" color="primary" onClick={() => setModalOpen(false)}>
                                        <div className="loading-spinner"></div>
                                    </Button>
                                )}
                                {isChanged === 2 && (
                                    <Button variant="contained" color="success" onClick={() => { setModalOpen(false); window.location.reload(); }}>
                                        <Typography variant="button">{t('vod.manage.info_tab.complete')}</Typography>
                                    </Button>
                                )}
                            </div>
                            <Button variant="outlined" color="primary" onClick={handleCancle}>
                                <Typography variant="button">{t('vod.manage.info_tab.previous')}</Typography>
                            </Button>
                        </div>
                    ) : (
                        <div className="dropzone-area" {...RootProps}>
                            {isDragReject ? (
                                <Typography className="drag-reject-text">{t('vod.manage.info_tab.invalid_file_format')}</Typography>
                            ) : isDragActive ? (
                                <div className="drag-active-content">
                                    <CloudUpload />
                                    <Typography>{t('vod.manage.info_tab.drop_to_upload')}</Typography>
                                </div>
                            ) : (
                                <div className="dropzone-content">
                                    <CloudUpload />
                                    <Typography>{t('vod.manage.info_tab.drag_and_drop')}</Typography>
                                    <Button variant="contained" color="primary">
                                        <Typography variant="button">{t('vod.manage.info_tab.add_file')}</Typography>
                                    </Button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
}

export default ThumbnailModal;
